import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "householdSelect", "presetRadio", "customPeriod"]

  connect() {
    this.toggleCustomPeriod()
  }

  open() {
    this.modalTarget.classList.remove("hidden")
  }

  close() {
    this.modalTarget.classList.add("hidden")
  }

  toggleAllHouseholds(event) {
    this.householdSelectTarget.disabled = event.target.checked
    if (event.target.checked) {
      this.householdSelectTarget.value = ""
    }
  }

  toggleCustomPeriod() {
    const customRadio = this.presetRadioTargets.find(r => r.value === "custom")
    if (customRadio && customRadio.checked) {
      this.customPeriodTarget.classList.remove("hidden")
    } else {
      this.customPeriodTarget.classList.add("hidden")
    }
  }

  submitForm(event) {
    event.preventDefault()
    const form = event.target
    const url = form.action
    const formData = new FormData(form)
    const csrfToken = document.querySelector("meta[name='csrf-token']")?.content

    fetch(url, {
      method: "POST",
      body: formData,
      headers: {
        "X-CSRF-Token": csrfToken,
        "Accept": "text/vnd.turbo-stream.html, text/csv"
      }
    }).then(response => {
      const contentType = response.headers.get("Content-Type") || ""
      if (contentType.includes("text/csv")) {
        const disposition = response.headers.get("Content-Disposition") || ""
        const filenameMatch = disposition.match(/filename="?([^"\s;]+)"?/)
        const filename = filenameMatch ? filenameMatch[1] : "download.csv"
        return response.blob().then(blob => {
          const a = document.createElement("a")
          a.href = URL.createObjectURL(blob)
          a.download = filename
          document.body.appendChild(a)
          a.click()
          const objectUrl = a.href
          a.remove()
          URL.revokeObjectURL(objectUrl)
          this.close()
        })
      } else if (contentType.includes("turbo-stream")) {
        return response.text().then(html => {
          document.getElementById("csv_modal_errors").innerHTML = ""
          Turbo.renderStreamMessage(html)
        })
      }
    })
  }
}
